// @ts-nocheck
import { Component, Inject, ViewEncapsulation, NO_ERRORS_SCHEMA } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  standalone: true,
  selector: 'app-small-dialog',
  templateUrl: './small-dialog.component.html',
  styleUrl: './small-dialog.component.scss',
  imports: [CommonModule, MatButtonModule, MatDialogModule],
  schemas: [NO_ERRORS_SCHEMA],
})
export class SmallDialogComponent {
  [key: string]: any;

  constructor(
    public dialogRef: MatDialogRef<SmallDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmitClick(): void {
    this.data.submit_btn_clicked = true;
    this.dialogRef.close(this.data);
  }
}
